import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import {useLocation} from "react-router-dom";

const AccountDetailEvents=({parentId,application,userData})=>{
    const location=useLocation();
    const list_name='account_events';
    const executeQuery=useRef(true);
    const renderListTab=useMemo(()=>{
        const navigateOnNew={route:'/event/new/',args:{state:{from:location.pathname,context:{parent_name:'Account',parent_field_name:'account_id',parent_field_value:parentId}}}};
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'Event'}
                entityParams={['account_id='+parentId,'_context='+['parent_name=Account'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'AccountDetailEvents.js'}
                initialState={{sorting:{sortModel:[{field:'reference',sort:'asc'}],}}}
                navigateOnNew={navigateOnNew}
                executeQuery={executeQuery}
            />
        ):null;
    },[parentId,application,userData,location.pathname]);

    return(renderListTab);
}
export default AccountDetailEvents;